/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic3,
  ManagerLogic3Interface,
} from "../../../contracts/manager/ManagerLogic3";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "earlyAccessIds",
        type: "uint256[]",
      },
    ],
    name: "BuyEarlyAccess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "GetInvestmentReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bonus",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToSelf",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToDead",
        type: "uint256",
      },
    ],
    name: "GetReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcUsdtPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "investmentCredentialId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "Invest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtToColdWallet",
        type: "uint256",
      },
    ],
    name: "RedeemUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "UsdtPurchaseUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsToBurn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketNumber",
        type: "uint256",
      },
    ],
    name: "WithdrawPromotionUsds",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lpUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_lpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stfUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_usdToStf",
    outputs: [
      {
        internalType: "uint256",
        name: "stf",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtStfLpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdsStfLpPrice",
        type: "uint256",
      },
    ],
    name: "_usdsStfLpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stfPriceFixedPoint18",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.StfPriceParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "calcStfPriceParamDigest",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "domainSeparator",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNumber",
        type: "uint256",
      },
    ],
    name: "getAction",
    outputs: [
      {
        internalType: "bool",
        name: "hasMore",
        type: "bool",
      },
      {
        internalType: "uint256[]",
        name: "actionIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "actionTypes",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "actionData",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getActionIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGlobalConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "oneDay",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investUsdtOnlyMinimal",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentCredentialUsdtToZbcNumerator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentCredentialUsdtToZbcDenominator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap0",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap1",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap2",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap3",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap4",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessUsdtStock",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessUsdtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessRedeemTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap5",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap6",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap7",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap8",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap9",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastUpdateTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardRate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardRateMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalSupplySource",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardPerTotalSourceStored",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap10",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap11",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap12",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap13",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap14",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investUsdtToBuyStf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investStfBurned",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdsRedeemUsdtToBuyStf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdsRedeemStfBurned",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.GlobalConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "billNumber",
        type: "uint256",
      },
    ],
    name: "getLpBill",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "lpAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lpEquivalentUsd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "apy",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastUpdateTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "finishTimestamp",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "finished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "cumulativeStfRewardClaimed",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "withdrawn",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "stfToSelf",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "stfToInviter1Address",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stfToInviter1Amount",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "stfToInviter2Address",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stfToInviter2Amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdtWithdrawn",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.Bill",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getLpPersonActiveBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getLpPersonFinishedBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getLpPersonWithdrawnBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getPerson",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "earlyAccessBought",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "inviter",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "investUsdtCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investZbcCost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accumulativeUsdsClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap3",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "gap4",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakedUsds",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakedSourceAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardPerTotalSourcePaid",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "reward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accumulativeReward",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "firstStakeTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastGetRewardTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeWithdrawnPromotionUsds",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakedLp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeStfRewardClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeLpWithdrawnUsdtSelf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeLpWithdrawnStfSelf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeLpWithdrawnStfInviter1",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeLpWithdrawnStfInviter2",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakedUsdsStfLp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeStfRewardClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeLpWithdrawnUsdsBurn",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeLpWithdrawnUsdsToStfSelf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeLpWithdrawnLpStfSelf",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeLpWithdrawnLpStfInviter1",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "UsdsStfLpCumulativeLpWithdrawnLpStfInviter2",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cumulativeUsdtPurchaseUsdsAmount",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.Person",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getPersonBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStfPriceParamTypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketNumbers",
        type: "uint256[]",
      },
    ],
    name: "getTicketNumber",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "billNumber",
        type: "uint256",
      },
    ],
    name: "getUsdsStfLpBill",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "lpAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lpEquivalentUsd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "apy",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastUpdateTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "finishTimestamp",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "finished",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "cumulativeStfRewardClaimed",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "withdrawn",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "stfToSelf",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "stfToInviter1Address",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stfToInviter1Amount",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "stfToInviter2Address",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "stfToInviter2Amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdsBurn",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdsToStf",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.UsdsStfLpBill",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getUsdsStfLpPersonActiveBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getUsdsStfLpPersonBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getUsdsStfLpPersonFinishedBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getUsdsStfLpPersonWithdrawnBill",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "oneDay",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investUsdtOnlyMinimal",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentCredentialUsdtToZbcNumerator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentCredentialUsdtToZbcDenominator",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "investmentDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessUsdtStock",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessUsdtPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "earlyAccessRedeemTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardPerDay",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewardPerDayMin",
            type: "uint256",
          },
        ],
        internalType: "struct ManagerType.GlobalConfigParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "setGlobalConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "investUsdtOnlyMinimal",
        type: "uint256",
      },
    ],
    name: "setInvestUsdtOnlyMinimal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "investmentCredentialUsdtToZbcNumerator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "investmentCredentialUsdtToZbcDenominator",
        type: "uint256",
      },
    ],
    name: "setInvestmentCredentialPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic3ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic3ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic3__factory extends ContractFactory {
  constructor(...args: ManagerLogic3ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic3> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic3>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic3 {
    return super.attach(address) as ManagerLogic3;
  }
  override connect(signer: Signer): ManagerLogic3__factory {
    return super.connect(signer) as ManagerLogic3__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic3Interface {
    return new utils.Interface(_abi) as ManagerLogic3Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic3 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic3;
  }
}
